import { Component } from '@ecs/Component';

export class CirclerAI implements Component {
  readonly type = 'CirclerAI';

  constructor(
    public circleRadius: number = 120,
    public circleSpeed: number = 0.02,
    public currentAngle: number = 0,
    public direction: 1 | -1 = 1
  ) {}
}